export enum NeutralColorToken {
  neutralColorHighPure = '#FFFFFF',
  neutralColorHighLight = '#FAFAFA',
  neutralColorHighMedium = '#F1F1F1',
  neutralColorHighDark = '#E3E3E3',
  neutralColorLowPure = '#0C111D',
  neutralColorLowLight = '#D0D5DD',
  neutralColorLowMedium = '#687288',
  neutralColorLowDark = '#474567',
}

export default NeutralColorToken

export type TNeutral =
  | 'neutralColorHighPure'
  | 'neutralColorHighLight'
  | 'neutralColorHighMedium'
  | 'neutralColorHighDark'
  | 'neutralColorLowPure'
  | 'neutralColorLowLight'
  | 'neutralColorLowMedium'
  | 'neutralColorLowDark'
